import { UpperCasePipe } from '@angular/common';
import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonCard, IonCardContent, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EDocumentType } from '@okcargo-apps/shared-domain';
import { ICompanyDocument } from '@okcargo-apps/shared-domain-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { UploadDocumentModalComponent } from '../../company/upload-document-modal/upload-document-modal.component';

@Component({
  selector: 'lib-notice-documentation-card',
  templateUrl: './notice-documentation-card.component.html',
  styleUrls: ['./notice-documentation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonCard, IonCardContent, TranslateModule, UpperCasePipe, DateFnsModule],
})
export class NoticeDocumentationCardComponent {
  private readonly modalCtrl = inject(ModalController);

  @Input()
  document!: ICompanyDocument;

  EDocumentType = EDocumentType;

  async showUploadDocumentModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UploadDocumentModalComponent,
      componentProps: {
        documentType: this.document.type,
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
